module.exports = __webpack_public_path__ + "static/9-f9e0166cebfcea95e53f11fd53e819d7.png";